import styled from 'styled-components';
import Tag from '@pedidosya/web-fenix/system/Tag';
import Divider from '@pedidosya/web-fenix/system/HorizontalDivider';
import { vendorItem as vendorItemTokens } from './vendorItem';
import FenixCardContainer from '../../CardContainer';

const vendorItemStyles = vendorItemTokens.categories.default;

export const CardContainer = styled(FenixCardContainer)`
  border-radius: 0;
  box-sizing: border-box;
  cursor: pointer;
  width: 100%;
  padding: 20px 0 16px 0;
  transition: all 0.1s ease-in;

  &:hover {
    background-color: #1004230a;
  }
`;

export const DividerWeb = styled(Divider)`
  position: relative;
  top: ${({ theme }) => theme.space(vendorItemStyles.shared.cardPadding)};
`;

export const TextSeparator = styled.span`
  color: inherit;
  margin-right: ${({ marginX }) => `${marginX ?? 2}px`};
  margin-left: ${({ marginX }) => `${marginX ?? 2}px`};
`;

export const TagWeb = styled(Tag)`
  &.vendor-status-action {
    text-transform: uppercase;
  }
`;

export const Header = styled.div`
  display: flex;
  position: relative;
  overflow: hidden;
  height: 144px;

  border-top-left-radius: ${({ theme }) =>
    theme.borderRadius(vendorItemStyles.shared.headerTopBorderRadius)};
  border-top-right-radius: ${({ theme }) =>
    theme.borderRadius(vendorItemStyles.shared.headerTopBorderRadius)};

  margin-bottom: ${({ theme }) =>
    theme.space(vendorItemStyles.shared.headerMarginBottom)};

  > picture,
  .header-image {
    height: 100%;
    width: 100%;
  }
`;

export const HeaderOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    0deg,
    rgba(16, 4, 35, 0.65),
    rgba(16, 4, 35, 0.65)
  );
`;

export const HeaderContent = styled.div`
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  padding: ${({ theme }) => theme.space(vendorItemStyles.shared.headerPadding)};
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
`;

export const HeaderTopRow = styled.div`
  display: flex;
  width: 100%;
  z-index: 1;
`;

export const HeaderCenterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  z-index: 1;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const HeaderBottomRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  z-index: 1;
`;

export const HeaderBottomRowLeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-start;

  gap: ${({ theme }) =>
    theme.space(vendorItemStyles.shared.headerBottomRowLeftColumnGap)};
`;

export const HeaderBottomRowRightColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-end;
  justify-content: flex-end;
  margin-left: auto;
`;

export const Body = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
`;

export const BodyLeftColumn = styled.div`
  flex-wrap: wrap;
  flex-direction: column;
`;

export const BodyRightColumn = styled.div`
  flex: 1;
  flex-wrap: wrap;
  flex-direction: column;

  margin-left: ${({ theme }) =>
    theme.space(vendorItemStyles.shared.bodyRightMarginLeft)};
`;

export const Content = styled.div`
  display: flex;
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  ${({ theme, token }) => theme.font(token)};
  gap: ${({ theme, gap }) => theme.space(gap)};
  color: ${({ theme, color }) => theme.color(color)};
  justify-content: ${({ justifyContent }) => justifyContent || 'normal'};
  padding-bottom: ${({ theme, paddingBottom }) => theme.space(paddingBottom)};
  padding-top: ${({ theme, paddingTop }) => theme.space(paddingTop)};
`;

export const BodyFavToggleIconContainer = styled.div`
  position: absolute;
  bottom: ${({ theme }) => theme.space('spacing-component-xsmall')};
  right: 0;
`;

export const CPCContainer = styled.div`
  padding-bottom: ${({ theme }) => theme.space('spacing-component-medium')};
  margin-bottom: 0;
`;
